import { queryClient } from "../client-query";
import { globalStore } from "../eventstore/global-store";
import { ofType } from "../eventstore/of-type.operator";
import { successNotificationFromPromise } from "../notifications/utils";
import {
  ALL_CONFIGURATIONS,
  ALL_PARTICIPATIONS,
  PARTICIPATION_SUMMARY,
} from "./resources";

export const participationEffects = [
  globalStore.pipe(ofType("REMOVE_PARTICIPATION_SUCCESS")).subscribe(() => {
    successNotificationFromPromise("participation-removed");
    queryClient.invalidateQueries([ALL_PARTICIPATIONS, PARTICIPATION_SUMMARY]);
  }),

  globalStore.pipe(ofType("POST_PARTICIPATION_SUCCESS")).subscribe(() => {
    successNotificationFromPromise("participation-submitted");
    queryClient.invalidateQueries([ALL_PARTICIPATIONS, PARTICIPATION_SUMMARY]);
  }),

  globalStore.pipe(ofType("UPDATE_PARTICIPATION_SUCCESS")).subscribe(() => {
    successNotificationFromPromise("participation-has-been-updated");
    queryClient.invalidateQueries([ALL_PARTICIPATIONS]);
  }),

  // Respond to Auth change
  globalStore
    .pipe(ofType("AUTH_DONE"))
    .subscribe(() =>
      queryClient.invalidateQueries([
        ALL_CONFIGURATIONS,
        ALL_PARTICIPATIONS,
        PARTICIPATION_SUMMARY,
      ])
    ),
];
